(function() {
    'use strict';
    angular
        .module('app.filter')
        .filter('trustUrl', trustUrl);

    function trustUrl($sce) {
        return function(url) {
            return $sce.trustAsResourceUrl(url);
        };
    }
})();

